import React from 'react'

function Expo() {
    return (
        <div className='container'>
            <div className="section_heading">
                <h1>Kalpataru <span> Ayurveda</span> Expo</h1>
            </div>
            <div className='row justify-content-between mb-5' >
                <div className='col-xl-8 col-lg-8 col-md-12 col-sm-12 col-xs-12 expo_col' >
                    <p>
                        Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs.
                        The passage is attributed to an unknown typesetter in the 15th century who is thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book. It usually begins with
                    </p>
                    <p>
                        The purpose of lorem ipsum is to create a natural looking block of text (sentence, paragraph, page, etc.) that doesn't distract from the layout.
                        A practice not without controversy, laying out pages with meaningless filler text can be very useful when the focus is meant to be on design, not content.
                    </p>
                    <p>
                        The purpose of lorem ipsum is to create a natural looking block of text (sentence, paragraph, page, etc.) that doesn't distract from the layout.
                        A practice not without controversy, laying out pages with meaningless filler text can be very useful when the focus is meant to be on design, not content.
                    </p>
                </div>
                <div className=' col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12' >
                    <img className='expo_img' src='/images/events/exh.jpg' alt='Loading..' />
                </div>
            </div>
        </div>
    )
}

export default Expo